<template>
  <div class="vantPage">
    <van-nav-bar
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :safe-area-inset-top="true"
    >
      <template #title>
        <img
          src="../../assets/images/logo.png"
          style="width: 83px; height: 16px"
        />
      </template>
      <template #left>
        <van-icon name="cross" color="black" size="20" />
      </template>
      <template #right>
        <van-icon name="ellipsis" color="black" size="20" />
      </template>
    </van-nav-bar>
    <van-form @submit="onSubmit">
      <input type="hidden" v-model="code" name="code" />
      <van-field
        v-model="name"
        name="name"
        :label="$t('1.您的姓名')"
        :placeholder="$t('请输入')"
        :rules="[{ required: true, message: $t('请输入您的姓名') }]"
        :required="true"
        error-message-align:left
      >
      </van-field>
      <van-field
        v-model="mobile"
        name="mobile"
        :label="$t('2.您的手机号码')"
        :placeholder="$t('请输入')"
        :rules="phoneRules"
        :required="true"
      />
      <van-field
        v-model="companyName"
        name="companyName"
        :label="$t('3.您所属公司')"
        :placeholder="$t('请输入')"
        :rules="[{ required: true, message: $t('请输入内容') }]"
        :required="true"
      />
      <van-field
        name="nameOrigin"
        :label="$t('4.新柏石名字的由来')"
        :rules="[{ required: true, message: $t('请选择内容') }]"
        :required="true"
      >
        <template #input>
          <van-radio-group v-model="nameOrigin" direction="horizontal">
            <van-radio name="1">{{ $t('三位创始人的名字组合') }}</van-radio>
            <van-radio name="2">{{ $t('为了方便好记') }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        name="characteristic"
        :label="$t('5.NewWork产品的最大特色')"
        :rules="[{ required: true, message: $t('请选择内容') }]"
        :required="true"
      >
        <template #input>
          <van-radio-group v-model="characteristic" direction="horizontal">
            <van-radio name="1">{{ $t('兼容性强') }}</van-radio>
            <van-radio name="2">{{ $t('线下全场景一站式解决方案') }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div style="margin: 16px">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          :loading="isLoading"
          >{{ $t('提交') }}</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from 'vue'
import { sendCode, getExhibition, postExhibition } from '@/services/api'
import {
  Form,
  NavBar,
  Button,
  Field,
  RadioGroup,
  Radio,
  Icon,
  Image as VanImage,
  Toast,
} from 'vant'
Vue.use(Form)
Vue.use(NavBar)
Vue.use(Field)
Vue.use(Button)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Icon)
Vue.use(VanImage)

export default {
  name: 'exhibition',
  created() {
    this.getVisitorInfo()
  },
  data() {
    return {
      id: '',
      name: '',
      username: '',
      mobile: '',
      companyName: '',
      nameOrigin: '',
      characteristic: '',
      code: '', // 添加code字段，
      wechatOpenId: '',
      isLoading: false,
      phoneRules: [
        {
          required: true,
          message: this.$t('请输入手机号'),
          trigger: 'blur',
        },
        {
          pattern: /^1[3456789]\d{9}$/,
          message: this.$t('手机号格式错误，请重新填写'),
        },
      ],
    }
  },
  methods: {
    async getValue() {
      try {
        const urlParams = new URLSearchParams(window.location.search)
        const code = urlParams.get('code')
        console.log('getValue--', code)
        const resq = await sendCode(code)
        console.log('getValue--code接口返回的openId', resq)
        this.wechatOpenId = resq
        console.log('getValue--this.wechatOpenId', this.wechatOpenId)
        return
      } catch (error) {}
    },

    async getVisitorInfo() {
      try {
        await this.getValue()
        console.log(this.wechatOpenId, 'getVisitorInfo--this.wechatOpenId')
        const res = await getExhibition(this.wechatOpenId)
        console.log('getVisitorInfo--接口返回的res', res)
        if (typeof res === 'object' && Object.keys(res).length !== 0) {
          console.log('是否走到这res.smsUrl', res)
          window.location.href = res.smsUrl
        } else {
          console.log('是否走到这的exhibition/vant', res)
          this.$router.replace('/exhibition/vant')
        }
      } catch (error) {
        console.error(error)
      }
    },
    //点击左边图标x
    onClickLeft() {
      this.$router.go(-1)
    },

    // 点击省略号...
    onClickRight() {},

    async onSubmit(values) {
      this.isLoading = true
      console.log('values', values)
      try {
        const resqq = await postExhibition({
          name: values.name,
          mobile: values.mobile,
          companyName: values.companyName,
          wechatOpenId: this.wechatOpenId,
        })
        console.log('提交的resqq', resqq)
        Toast(this.$t('提交成功'))
        this.isLoading = false
        this.id = resqq
        this.$router.replace(`/visitorInvitationBySelf/?id=${this.id}`)
      } catch (error) {
        console.error(error)
        Toast(this.$t('提交失败，请重试'))
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>





<style  scoped lang="less">
::v-deep .van-form {
  background-color: rgba(0, 0, 0, 0);
  background-image: url('../../assets/images/bg.png');
  background-size: cover;
}
::v-deep .van-cell {
  flex-wrap: wrap !important;
  background-color: rgba(0, 0, 0, 0) !important;
}

::v-deep .van-field__label {
  display: block;
  width: 100vw !important;
  flex-shrink: 0;
  font-size: 16px !important;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  margin-bottom: 8px;
  color: #1e2329;
}

::v-deep .van-field--error input.van-field__control,
.van-field--error .van-field__control::placeholder,
.van-field--error::placeholder {
  color: #cbd9ed !important;
  /* padding: 10px 5px !important; */
  border-radius: 10px !important;
  border: 1px solid rgb(255, 63, 63) !important;
}

::v-deep .van-field__control::placeholder {
  color: #aaa !important;
}
::v-deep .van-field--error::placeholder {
  color: #aaa !important;
}
.van-field__control::placeholder ::v-deep .van-field__control {
  padding: 10px 5px !important;
  border: 1px solid rgba(255, 63, 63, 0) !important;
}

::v-deep .van-radio-group--horizontal {
  display: block !important;
}

::v-deep .van-radio--horizontal {
  padding: 10px 0;
}

::v-deep .van-field__body input {
  width: 335px;
  height: 48px;
  background: #ffffff;
  border-radius: 8px;
  padding-left: 16px;
}
.van-cell::after {
  border-bottom: 0;
}
::v-deep .van-field__body input {
  font-size: 16px;
}
.van-field--error .van-field__control {
  padding-left: 16px;
}
</style>
